<app-aluno-portal></app-aluno-portal>
<div>
  <mat-card class="mat-elevation-z8" style="padding: 1.5rem !important">
    <mat-card-content>
      <form [formGroup]="form">
        <div class="grid grid--auto-fill">
          <div class="flex align-center prl-1-5">
              <mat-slide-toggle formControlName="materialLiberado" (change)="changeMaterialLiberado($event)" color="primary">Conteúdo Digital</mat-slide-toggle>
          </div>
      </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
